import { useLayoutEffect, useState } from 'react';
import type { ExtractState, StoreApi } from 'zustand';
import { useShallow } from 'zustand/shallow';

type ReadonlyStoreApi<T> = Pick<StoreApi<T>, 'getState' | 'getInitialState' | 'subscribe'>;

/**
 * @deprecated Use original zustand 'useStore' instead
 */
export function useStoreEnhance<S extends ReadonlyStoreApi<unknown>>(api: S | undefined) {
  const [store, setStore] = useState<ExtractState<S> | undefined>();

  useLayoutEffect(() => {
    if (api) {
      const unsubscribe = api.subscribe((state) => {
        setStore(state as ExtractState<S>);
      });
      setStore(api.getState() as ExtractState<S>);
      return unsubscribe;
    } else {
      setStore(undefined);
    }
  }, [api]);

  return store;
}

export function useShallowEnhance<S, F extends (keyof S)[]>(fields: F) {
  return useShallow((store: S) =>
    fields.reduce(
      (acc, field) => {
        acc[field] = store[field] as any;
        return acc;
      },
      {} as Pick<S, F[number]>
    )
  );
}
